module.exports = __webpack_public_path__ + "img/down-sc3.f8ffef7a.png";